module.exports = __webpack_public_path__ + "img/collect_act.12b267fd.svg";